import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'

export const StyledDrawer = styled.nav`
    width: 100%;
    background-color: ${({ theme }) => theme.colors.secondary.grey95};
    display: ${({ $isOpen }) => $isOpen ? 'flex' : 'none'};
    position: fixed;
    top: ${pxToRem(50)};
    left: 0;
    height: 100vh;
`